import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-comparision-five-report',
  templateUrl: './comparision-five-report.component.html',
  styleUrls: ['./comparision-five-report.component.scss']
})
export class ComparisionFiveReportComponent implements OnInit {
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  booth_types = [{'display_name': 'Booth', 'value': 1}, {'display_name': 'Govt Institute', 'value': 5}, {'display_name': 'Private Institute', 'value': 4}, {'display_name': 'Own parlour', 'value': 3}, {'display_name': 'Parlour', 'value': 2}, {'display_name': 'Other unions', 'value': 6}, {'display_name': 'Other State', 'value': 7}, {'display_name': 'Whole Sale Dealer', 'value': 9}, {'display_name': 'Event / Special Order', 'value': 8}, {'display_name': 'Society', 'value': 10}]
  selected_month: any;
  selected_booth_type_list: any;

  inp_types: any;
  selected_inp_type: any = null;
  inp_years: any;
  selected_year: any = null;
  selected_from_date: any = null;
  selected_to_date: any = null;
  session_list: any = [];
  selected_session: any = null;

  is_document_available: boolean = true;
  data_avaliable: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(private httpService: HttpService) {
    this.httpService.serveYears().subscribe((inp_years: []) => {
      console.log(inp_years);
      this.inp_years = inp_years;
    }, (error) => {
      console.log(error);
    });

    this.httpService.getSession().subscribe((session_list: []) => {
      console.log(session_list);
      this.session_list = session_list;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    let data_dict = {}
    if (this.selected_inp_type == "Month") {
      data_dict = {
        'selected_inp_type': this.selected_inp_type,
        'selected_year': this.selected_year,
        'selected_session': this.selected_session,
        'selected_month_list': this.selected_month,
        'selected_booth_type_list': this.selected_booth_type_list
      };
      console.log(data_dict)
    } else {
      data_dict = {
        'selected_inp_type': this.selected_inp_type,
        'selected_from_date': this.selected_from_date,
        'selected_session': this.selected_session,
        'selected_to_date': this.selected_to_date,
        'selected_booth_type_list': this.selected_booth_type_list
      };
    }
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveCompReportFive(data_dict).subscribe((data) => {
      console.log(data);
      this.is_document_available = true;
      if(data['data_avaliable'] == false){
        this.document_file = null
        alert('Sorry no data avaliable')
        return false
      }
      this.document_file = data;
      this.data_avaliable = true
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  ngOnInit() {
  }

}
